/* tslint:disable */
/* eslint-disable */
/**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiCompetitionsAllGet200Response } from '../models';
// @ts-ignore
import type { ApiCompetitionsEnabledGet200Response } from '../models';
// @ts-ignore
import type { ApiCompetitionsGet200Response } from '../models';
/**
 * CompetitionsApi - axios parameter creator
 * @export
 */
export const CompetitionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all competitions from Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompetitionsAllGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/competitions/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get configured countries for the AllCompetitions display
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompetitionsCountriesConfigGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/competitions/countries-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get enabled competitions from configured leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompetitionsEnabledGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/competitions/enabled`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get enabled and all competitions from configured leagues and Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompetitionsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/competitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompetitionsApi - functional programming interface
 * @export
 */
export const CompetitionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompetitionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all competitions from Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompetitionsAllGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiCompetitionsAllGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompetitionsAllGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionsApi.apiCompetitionsAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get configured countries for the AllCompetitions display
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompetitionsCountriesConfigGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompetitionsCountriesConfigGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionsApi.apiCompetitionsCountriesConfigGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get enabled competitions from configured leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompetitionsEnabledGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiCompetitionsEnabledGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompetitionsEnabledGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionsApi.apiCompetitionsEnabledGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get enabled and all competitions from configured leagues and Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompetitionsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiCompetitionsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompetitionsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionsApi.apiCompetitionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompetitionsApi - factory interface
 * @export
 */
export const CompetitionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompetitionsApiFp(configuration)
    return {
        /**
         * Get all competitions from Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompetitionsAllGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiCompetitionsAllGet200Response> {
            return localVarFp.apiCompetitionsAllGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get configured countries for the AllCompetitions display
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompetitionsCountriesConfigGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiCompetitionsCountriesConfigGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get enabled competitions from configured leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompetitionsEnabledGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiCompetitionsEnabledGet200Response> {
            return localVarFp.apiCompetitionsEnabledGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get enabled and all competitions from configured leagues and Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompetitionsGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiCompetitionsGet200Response> {
            return localVarFp.apiCompetitionsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompetitionsApi - object-oriented interface
 * @export
 * @class CompetitionsApi
 * @extends {BaseAPI}
 */
export class CompetitionsApi extends BaseAPI {
    /**
     * Get all competitions from Sportradar API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionsApi
     */
    public apiCompetitionsAllGet(options?: RawAxiosRequestConfig) {
        return CompetitionsApiFp(this.configuration).apiCompetitionsAllGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get configured countries for the AllCompetitions display
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionsApi
     */
    public apiCompetitionsCountriesConfigGet(options?: RawAxiosRequestConfig) {
        return CompetitionsApiFp(this.configuration).apiCompetitionsCountriesConfigGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get enabled competitions from configured leagues
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionsApi
     */
    public apiCompetitionsEnabledGet(options?: RawAxiosRequestConfig) {
        return CompetitionsApiFp(this.configuration).apiCompetitionsEnabledGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get enabled and all competitions from configured leagues and Sportradar API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionsApi
     */
    public apiCompetitionsGet(options?: RawAxiosRequestConfig) {
        return CompetitionsApiFp(this.configuration).apiCompetitionsGet(options).then((request) => request(this.axios, this.basePath));
    }
}

